<template>
  <div class="repair-page">
    <div class="repair-card">
      <div class="repair-header">
        <div class="repair-title">电话报修</div>
        <div class="repair-divider"></div>
        <div class="repair-toolbar">
          <div class="repair-actions">
            <el-button size="small" class="repair-btn-add" @click="_openAddOwnerRepairModal"><i class="el-icon-plus"></i>添加报修登记</el-button>
            <el-button size="small" class="repair-btn-refresh" title="刷新" @click="_queryOwnerRepairMethod"><i class="el-icon-refresh-right"></i></el-button>
          </div>
          <div class="repair-search-group">
            <el-select v-model="ownerRepairManageInfo.conditions.state" size="small" clearable placeholder="请选择报修状态" class="repair-search-select">
              <el-option v-for="item in ownerRepairManageInfo.states" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
            </el-select>
            <el-select v-model="ownerRepairManageInfo.conditions.repairType" size="small" clearable placeholder="请选择报修类型" class="repair-search-select">
              <el-option v-for="item in ownerRepairManageInfo.repairTypes" :key="item.repairType" :label="item.repairTypeName" :value="item.repairType" />
            </el-select>
            <el-input v-model.trim="ownerRepairManageInfo.conditions.tel" size="small" clearable placeholder="请输入报修电话" class="repair-search-input" />
            <el-input v-model.trim="ownerRepairManageInfo.conditions.repairName" size="small" clearable placeholder="请输入报修人" class="repair-search-input" />
            <el-input v-model.trim="ownerRepairManageInfo.conditions.repairId" size="small" clearable placeholder="请输入工单编号" class="repair-search-input" />
            <el-button size="small" class="repair-btn-search" @click="_queryOwnerRepairMethod"><i class="el-icon-search"></i>搜索</el-button>
          </div>
        </div>
      </div>

      <div class="repair-table-section">
        <el-table v-loading="loading" :data="ownerRepairManageInfo.ownerRepairs" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" label="所在小区" min-width="150" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.communityName || '-' }}</template></el-table-column>
          <el-table-column prop="repairObjName" label="位置" min-width="160" show-overflow-tooltip />
          <el-table-column prop="repairTypeName" label="报修类型" min-width="120" show-overflow-tooltip />
          <el-table-column prop="repairName" label="报修人" min-width="110" show-overflow-tooltip />
          <el-table-column prop="tel" label="联系方式" min-width="130" show-overflow-tooltip />
          <el-table-column prop="createTime" label="提交时间" min-width="170" show-overflow-tooltip />
          <el-table-column prop="timeout" label="超时时间" min-width="170" show-overflow-tooltip />
          <el-table-column label="预约时间" min-width="260" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatAppointmentRange(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="状态" min-width="110">
            <template slot-scope="scope"><span :class="['status-tag', statusClass(scope.row.state)]">{{ statusText(scope.row) }}</span></template>
          </el-table-column>
          <el-table-column label="操作" min-width="120" fixed="right">
            <template slot-scope="scope">
              <span class="action-links">
                <a v-if="['1000', '1200'].includes(scope.row.state)" class="action-link" @click="_openEditOwnerRepairModel(scope.row)">编辑</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="repair-pagination">
        <span class="pagination-total">共{{ ownerRepairManageInfo.total }}条</span>
        <el-pagination :current-page="ownerRepairManageInfo.page" :page-size="ownerRepairManageInfo.rows" layout="prev, pager, next, jumper" :total="ownerRepairManageInfo.total" @current-change="handleCurrentChange" />
        <el-select v-model="ownerRepairManageInfo.rows" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <add-owner-repair ref="addOwnerRepair" @success="_queryOwnerRepairMethod" />
    <edit-owner-repair ref="editOwnerRepair" @success="_queryOwnerRepairMethod" />
    <delete-owner-repair ref="deleteOwnerRepair" @success="_queryOwnerRepairMethod" />
  </div>
</template>

<script>
import * as ownerRepairManageApi from '@/api/work/ownerRepairManageApi'
import AddOwnerRepair from '@/components/work/addOwnerRepair'
import EditOwnerRepair from '@/components/work/editOwnerRepair'
import DeleteOwnerRepair from '@/components/work/deleteOwnerRepair'
import { getDict } from '@/api/community/communityApi'

export default {
  name: 'OwnerRepairManageList',
  components: { AddOwnerRepair, EditOwnerRepair, DeleteOwnerRepair },
  data() {
    return {
      loading: false,
      ownerRepairManageInfo: {
        ownerRepairs: [], total: 0, page: 1, rows: 10, repairTypes: [], states: [],
        conditions: { repairId: '', repairName: '', tel: '', repairType: '', state: '', reqSource: 'pc_mobile' }
      }
    }
  },
  created() {
    this._listOwnerRepairs(1, this.ownerRepairManageInfo.rows)
    this._listRepairTypes(1, 100)
    this._loadStates()
  },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 500, height: '44px', padding: '0', border: 'none' } },
    cellStyle() { return { color: '#1D2129', height: '48px', padding: '0', border: 'none' } },
    _loadStates() { getDict('r_repair_pool', 'state').then(data => { this.ownerRepairManageInfo.states = data || [] }) },
    async _listRepairTypes(page, rows) {
      const res = await ownerRepairManageApi.listRepairSettings({ page, row: rows })
      this.ownerRepairManageInfo.repairTypes = res.data || []
    },
    async _listOwnerRepairs(page, rows) {
      this.loading = true
      try {
        const conditions = { ...this.ownerRepairManageInfo.conditions, page, row: rows }
        const res = await ownerRepairManageApi.listOwnerRepairs(conditions)
        this.ownerRepairManageInfo.ownerRepairs = res.data || []
        this.ownerRepairManageInfo.total = Number(res.total || res.records || 0)
        this.ownerRepairManageInfo.page = page
        this.ownerRepairManageInfo.rows = rows
      } finally {
        this.loading = false
      }
    },
    statusText(row) { return row.state === '1800' && ['001', '002'].includes(row.returnVisitFlag) ? `${row.stateName}(定时任务处理)` : (row.stateName || '-') },
    formatAppointmentRange(row) {
      if (row.appointmentStartTime && row.appointmentEndTime) {
        return `${row.appointmentStartTime} 至 ${row.appointmentEndTime}`
      }
      return row.appointmentTime || '-'
    },
    statusClass(state) { return ['1000', '1200'].includes(state) ? 'status-wait' : (['1800', '1900'].includes(state) ? 'status-done' : 'status-other') },
    _openAddOwnerRepairModal() { this.$refs.addOwnerRepair.open() },
    _openEditOwnerRepairModel(row) { this.$refs.editOwnerRepair.open(row) },
    _openDeleteOwnerRepairModel(row) { this.$refs.deleteOwnerRepair.open(row) },
    _queryOwnerRepairMethod() { this._listOwnerRepairs(1, this.ownerRepairManageInfo.rows) },
    handleSizeChange(val) { this.ownerRepairManageInfo.rows = val; this._listOwnerRepairs(1, val) },
    handleCurrentChange(val) { this._listOwnerRepairs(val, this.ownerRepairManageInfo.rows) }
  }
}
</script>

<style scoped>
.repair-page { height: 100%; background: #F5F8FC; }
.repair-card { min-height: 100%; background: #FFFFFF; border-radius: 0 0 12px 12px; display: flex; flex-direction: column; overflow: hidden; }
.repair-header { padding: 20px 24px 12px; flex-shrink: 0; }
.repair-title { font: 600 16px/22px 'PingFang SC', sans-serif; color: #1D2129; }
.repair-divider { height: 1px; background: #DCE6F5; margin: 12px 0; }
.repair-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.repair-actions, .repair-search-group, .action-links, .repair-pagination { display: flex; align-items: center; }
.repair-actions { gap: 12px; }
.repair-search-group { gap: 12px; margin-left: auto; flex-wrap: wrap; justify-content: flex-end; }
.repair-btn-add { height: 38px; padding: 0 16px; background: #0E76FF; border: none; border-radius: 10px; color: #fff; font-size: 14px; }
.repair-btn-refresh { width: 38px; height: 38px; padding: 0; border-radius: 10px; border: 1px solid #DCE6F5; color: #364153; background: #fff; }
.repair-btn-search { height: 38px; padding: 0 16px; border-radius: 10px; border: 1px solid #0E76FF; background: #fff; color: #0E76FF; }
.repair-search-input, .repair-search-select { width: 170px; }
.repair-search-group >>> .el-input__inner { height: 38px; border-radius: 10px; border-color: #DCE6F5; color: #1D2129; }
.repair-table-section { flex: 1; padding: 12px 24px 0; overflow: auto; }
.repair-table-section >>> .el-table { border-radius: 8px; overflow: hidden; }
.repair-table-section >>> .el-table::before { display: none; }
.repair-table-section >>> .el-table th, .repair-table-section >>> .el-table td { border: none; }
.action-links { gap: 8px; white-space: nowrap; }
.action-link { color: #0E76FF; cursor: pointer; font-size: 14px; }
.action-link.danger { color: #F53F3F; }
.link-separator { width: 1px; height: 12px; background: #DCE6F5; }
.status-tag { display: inline-flex; align-items: center; justify-content: center; min-width: 58px; height: 24px; padding: 0 8px; border-radius: 6px; font-size: 13px; }
.status-wait { background: #FFF7E8; color: #D46B08; }
.status-done { background: #E8F7EF; color: #0E8A45; }
.status-other { background: #E8F3FF; color: #0E76FF; }
.repair-pagination { justify-content: flex-end; gap: 8px; padding: 16px 24px 24px; flex-shrink: 0; }
.pagination-total { color: #6A7282; font-size: 14px; }
.pagination-size-select { width: 96px; }
.pagination-size-select >>> .el-input__inner { height: 32px; border-radius: 8px; }
@media (max-width: 1200px) { .repair-toolbar { align-items: flex-start; flex-direction: column; } .repair-search-group { margin-left: 0; justify-content: flex-start; } }
</style>
